import UserObject from '@/docs-partials/api/schema/user-object.mdx';
import * as React from 'react';
export default {
  UserObject,
  React
};